export default __webpack_public_path__ + "static/media/profit_graph_card.d73d36a1.png";